const AboutZeuss = () => {
  return (
    <>
      <section className="WhatPrcog pb-0" id="about">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h6>Coin</h6>
                <h4>Empower Local Impact</h4>
           
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              {/* <div data-aos="fade-right" data-aos-duration="2000"> */}
              <div className="image">
                <img src="/images/whatzeuss.png" alt="" />
              </div>
              {/* </div> */}
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              {/* <div data-aos="fade-left" data-aos-duration="2000"> */}
              <div className="content">
                <img src="/images/quote.png" alt="" />
                <h4>
                Some startups maximize capital, while others are unicorn public benefit start-ups. We're chasing unicorns of public good. 
We focus on startups who use decentralized solutions innovate around localized governance & community decision-making and create inclusive economic models.
We love startups aligned to community capital & sustainable development goals. 
The $POCKET token community acts like an LP in our fund.
                </h4>
                {/* <div className="label">
                  <h5>Your Name</h5>
                  <span>Co-Founder of</span>
                  <label></label>
                </div> */}
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default AboutZeuss;
